export enum CurrencyEnum {
  USD = "USD",
  EUR = "EUR",
  AMD = "AMD",
}
